module.exports = __webpack_public_path__ + "static/img/logo_ico.bdafd2e3.svg";